export let ContentSingleProps = {
    contentLink: {
        default: 'about-us'
    },
    contentType: {
        default: 'page'
    }
}